export const zh = {
    "register success": "註冊成功，請等待審核通過。",


    "KYC not found for this user.": "此用戶未找到KYC資料",
    "KYC status is not approved.": "KYC狀態未獲批准",
    "Invalid token": "無效的令牌",
    "Unauthorized": "請先登入",

    "addCart Success": "新增到購物車",



    "timeout": "已超時",
    "pending": "待處理",
    "paid": "已付款",
    "processing": "待審核",
    "complete": "已完成",

    "apply": {
        "pending": "待審核",
        "contactedNoResponse": "已聯絡未回覆",
        "schedulingInterview": "安排面試中",
        "interviewedSecondReview": "已面試二審中",
        "approved": "通過",
        "rejected": "駁回",
    },


    "activityStatus": {
        pending: "待處理",
        approved: "通過",
        rejected: "駁回",
    },

    "orderPaymentStatus": {
        unpaid: "未付款",
        paid: "已付款",
        failed: "付款失敗",
    },

    "negotationStatus": {
        pending: "待處理",
        dispatch: "已派遣",
        rejected: "駁回",
        approved: "通過",
    },

    "orderShipStatus": {
        preparing: "備貨中(庫存不足)",
        pending: "待發貨",
        inTransit: "配送中",
        delivered: "已送達",

    },
    "orderStatus": {
        pending: "待確認",
        completed: "完成",
        cancelled: "已取消",
    },
    "userIdentityType": {
        'general': '一般會員',
        'quasi-small': '準小盤',
        'small': '小盤',
        'quasi-mid': '準中盤',
        'mid': '中盤',
        'quasi-large': '準大盤',
        'large': '大盤',
    },

    "self-pickup": '自取',
    'delivery': '宅配',
    "Taipei": '台北',
    'Taichung': '台中',
    'Kaohsiung': '高雄',



    "creditCard": "信用卡",
    "bankTransfer": "匯款",
    "offline": "門市",

    "donate": "捐贈",
    "personal": "個人",
    "company":"公司",

    'true':"是",
    'false':"否",

        days: "天",
    hours: "時",
    minutes: "分",
    seconds: "秒",


    male: "男",
    female: "女",
    unknown: "不詳",

    header: {
        artAuction: "藝品拍賣",
        onlineGallery: "線上藝廊",
        artFocus: "藝術焦點",
        customerService: "客戶服務",
        productType: "產品分類",
        aboutUs: "關於我們",
        contactUs: "聯絡我們",
        message: "訊息通知",
        news: "最新消息",
        calendar: "行事曆",


    },
    newsType: {
  
    },
    memberCenterType: {
        userinfo: "基本資料",
        userGrade: "會員資格累積",
        message: "訊息通知",
        usercollar: "績效領條",
        negotiation: "協談申請",
        negotiationdispatch: "被指派協談",
        orderrecord: "訂單紀錄",
        event: "活動專區",
        recommend: "被推薦 / 需輔導人",
        team: "團隊成員列表",
        changepw: "更改密碼",
        vouchers: "會員購物金",



       

        payrecord: "消費紀錄",


        cue1: "欲申請鑑價藏品，須先登入帝愛會員",
        login: "會員登入"

    },
   
    grade: {
        'general': "一般",
        'quasi-small': "準小盤",
        'small': "小盤",
        'quasi-mid': "準中盤",
        'mid': "中盤",
        'quasi-large': "準大盤",
        'large': "大盤"
    },
    path: {
      
        intro: "介紹",
      
        online: "線上",
        theme: "當前",
        past: "過往",

       

        cart: "購物車",
      
        product: "產品",


     
        customerservice: "客戶服務",
        aboutus: "關於我們",
        contactus: "關於我們",


        terms: "服務條款",
        rules: "簡介",




        membercenter: "會員中心",
       

        login: "登入",
        register: "註冊",
        "": "首頁",



    }



}